import { Components, Theme } from '@mui/material';

declare module '@mui/material/TableContainer' {
  interface CustomComponentsProps {
    bordered: true;
  }
}
export const MuiTableContainer: Components<
  Omit<Theme, 'components'>
>['MuiTableContainer'] = {
  styleOverrides: {
    root: {
      border: 'none',

      variants: [
        {
          props: { bordered: true },
          style: ({ theme }) => ({
            border: `1px solid ${theme.palette.surface.outlineVariant}`,
          }),
        },
      ],
    },
  },
};
